import { render } from "./ContentblockFAQ.vue?vue&type=template&id=a1b546ec&scoped=true"
import script from "./ContentblockFAQ.vue?vue&type=script&lang=js"
export * from "./ContentblockFAQ.vue?vue&type=script&lang=js"

import "./ContentblockFAQ.vue?vue&type=style&index=0&id=a1b546ec&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b546ec"]])

export default __exports__